import React, { useState } from "react";
import {
  Box, Grid, Card, CardMedia, CardContent,
  Typography, Button, IconButton, Chip, Tooltip,
  Divider,
} from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import NoImage from "../../assets/aboutusicon.png"
import logger from "../../Utils/logger";
// ── Sample Data ───────────────────────────────────────────────────────────────

function calculateFinalPrice(item) {
  const offerPrice = item?.offer_price || 0;
  const offerDetails = item?.offer_details;

  // ❌ No offer OR not a Discount coupon
  if (!offerDetails || offerDetails.couponType !== "Discount") {
    return offerPrice;
  }

  const { flatTypeId, flatAmount } = offerDetails;

  let discount = 0;

  if (flatTypeId === 1) {
    // Flat amount (₹)
    discount = flatAmount || 0;
  } else if (flatTypeId === 2) {
    // Percentage (%)
    discount = (offerPrice * (flatAmount || 0)) / 100;
  }

  const finalPrice = offerPrice - discount;

  return Math.max(finalPrice, 0);
}

// ── Layout Toggle ─────────────────────────────────────────────────────────────

const LayoutToggle = ({ layout, setLayout,openSearch ,openFilter}) => (
      <Box
          style={{width:"100%",display: "flex",
    justifyContent: "space-between",marginTop:"20px"}}
            >
              <Box>
              <Typography fontSize={20} fontWeight={600} color={"rgb(113, 129, 152)"}>
                Explore Products
              </Typography>
              </Box>
      
              <Box>
                <IconButton onClick={(e)=>{openSearch()}}>
                  <SearchIcon />
                </IconButton>
      
                <IconButton onClick={() => setLayout(layout === "grid" ? "list" : "grid")}>
                  {layout === "grid" ? <ViewListIcon /> : <ViewModuleIcon />}
                </IconButton>
      
                <IconButton onClick={openFilter}>
                  <TuneIcon />
                </IconButton>
              </Box>
            </Box>
);

const ExploreHeader = ({ layout, setLayout, openSearch, openFilter }) => (
  
      <LayoutToggle layout={layout} setLayout={setLayout} />
  
);

// ── Grid Card ─────────────────────────────────────────────────────────────────

// ── Grid Card ─────────────────────────────────────────────────────────────────

const GridCard = ({ index,item,onIncrement,onDecrement,GotoDetails }) => (
  <Card 
    onClick={(e) => GotoDetails(e, item)}
  sx={{
    borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    position: "relative", height: "100%",
    display: "flex", flexDirection: "column"   // ← card itself is a column
  }}>
    {item.offer_details && (
<Chip
  label={`${
    item?.offer_details?.flatTypeId === 1 ? "₹" : ""
  }${item?.offer_details?.flatAmount || 0}${
    item?.offer_details?.flatTypeId === 2 ? "%" : ""
  }${
    item?.offer_details?.couponType === "CashBack"
      ? " Cashback"
      : item?.offer_details?.couponType === "Discount"
      ? " Off"
      : ""
  }`}
  size="small"
  sx={{
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
    bgcolor: "#e8f5e9",
    color: "#00B177",
    fontWeight: 700,
    fontSize: "11px", // ✅ correct
  }}
/>
    )}

  
            <Box sx={{ height: "150px", padding:"10px" }}>
                  <CardMedia
                    component="img"
                     image={`${process.env.REACT_APP_IMAGE_BASE_URL}/${item.image_path}`}
                    sx={{
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                     /*  borderRadius:"50px" */
                    }}
                  />
                </Box>
   

    <CardContent sx={{
      pb: "12px !important", px: 1.5, pt: 1,
      display: "flex", flexDirection: "column", flexGrow: 1  // ← stretches to fill card
    }}>
 <Typography
  fontWeight={600}
  fontSize="13px"
  textAlign="center"
  mb={1}
  lineHeight={1.3}
  color={"#384F6F"}
  sx={{
    display: "-webkit-box",
    WebkitLineClamp: 2,       // limit to 2 lines
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    minHeight: "34px"         // keeps height consistent (important for grid alignment)
  }}
>
  {item.mv_name}
</Typography>
      {/* Price row — grows to fill space, button stays at bottom */}
<div style={{display:"flex",    justifyContent:"center"}}>
<Box
  sx={{
    background: "linear-gradient(180deg, rgba(56, 79, 111, 0.002) 0%, rgba(56, 79, 111, 0.05) 100%)",

    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    mb: 1.5,
    width: "100%",   // fixed width
    height: "48px",   // fixed height
    flexShrink: 0,
    boxShadow: "4px 4px 10px 0px rgb(0 0 0 / 9%)"
  }}
>
  {/* Trial Price */}
  <Box sx={{ width: "50%", textAlign: "center", py: 1, px: 1.5 }}>
    <Typography fontSize="10px" color="text.secondary" lineHeight={1.2}>
      Trial Price
    </Typography>
    <Typography fontSize="14px" fontWeight={700} color="#00B177" lineHeight={1.3}>
      ₹{calculateFinalPrice(item)?.toFixed(2)}
    </Typography>
  </Box>

  {/* Vertical Divider */}
  <Divider orientation="vertical" flexItem />

  {/* MRP */}
  <Box sx={{ width: "50%", textAlign: "center", py: 1, px: 1.5 }}>
    <Typography fontSize="10px" color="text.secondary" lineHeight={1.2}>
      MRP
    </Typography>
    <Typography
      fontSize="13px"
      color="text.secondary"
      lineHeight={1.3}
      sx={{ textDecoration: "line-through" }}
    >
      ₹{item.mrp}
    </Typography>
  </Box>
</Box>
</div>
{item.mycount > 0 ? (
  <Box

     sx={{
       display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
height:"30px",
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
        bgcolor:"#00B177",
      color: "#fff",
      mt: "auto",
 
    }}

  >
    <Button
        onClick={(e) =>
                  onDecrement(e, index, item.slot_id, item.mycount)
                }
      sx={{ minWidth: "30px", color: "#fff" }}
    >
      -
    </Button>

    <Typography fontWeight={600}>{item.mycount}</Typography>

    <Button
         onClick={(e) =>
                  onIncrement(
                    e,
                    index,
                    item.slot_id,
                    item.mycount,
                    "add"
                  )
                }
      sx={{ minWidth: "30px", color: "#fff" }}
    >
      +
    </Button>
  </Box>
) : <>{ item.active_count > 0 && item.active ?<>
  <Button
    fullWidth
    variant="outlined"
    size="small"
    onClick={(e)=>{onIncrement(e,index,item.slot_id,0,"add")}}
    sx={{
      borderColor:"#00B177",
      color:"#00B177",
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
      mt: "auto",

                          "&:hover": {
      borderColor: "#00B177",
      color: "#00B177",
      backgroundColor: "transparent", // keeps it clean (optional)
    },
         
 
    }}
    
  >
    Add
  </Button></>:<>
    <Button
    fullWidth
    variant="outlined"
    size="small"
    //onClick={(e)=>{onIncrement(e,index,item.slot_id,0,"add")}}
    sx={{
      background: "#E5E7EB",
       color: "#fff",
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
      mt: "auto",
      border:"none"
 
    }}
    
  >
    Add
  </Button>
  
  </>}

</>}
    </CardContent>
  </Card>
);

// ── List Card ─────────────────────────────────────────────────────────────────
const truncateText = (text, limit) => {
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};

const ListCard = ({ index, item, onAdd, onIncrement, onDecrement,GotoDetails}) => {
  return (
    <Card
     onClick={(e) => GotoDetails(e, item)}
      sx={{
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        mb: 1.5,
        minHeight: "130px", // ✅ flexible instead of fixed
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* MAIN CONTENT */}
      <Box sx={{ display: "flex", flex: 1,alignItems:"center",paddingLeft:"10px" }}>
        {/* IMAGE */}
    <Box
     color={"#384F6F"}
      sx={{
        width: 90,
        height: 90,
        borderRadius: 2,
        overflow: "hidden",
        background: "#fff",
        flexShrink: 0,
      }}
    >
      <img
        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.image_path}`}
        alt={item.mv_name}
        style={{ width: "100%", height: "100%", /* objectFit: "cover"  */}}
      />
    </Box>


        {/* RIGHT CONTENT */}
        <Box
          sx={{
            flex: 1,
            px: 1.5,
            py: 1.2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {/* TOP */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            {/* TITLE */}
            <Box
              sx={{
                maxWidth: "75%",
                overflow: "hidden",
              }}
            >
              <Typography
                fontWeight={700}
                fontSize="14px"
                noWrap
                 color={"#384F6F"}
                sx={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap", // ✅ fixed
                }}
              >
                {truncateText(item.mv_name, 25)}
              </Typography>
            </Box>

            {/* TRAY */}
            <Typography
              fontSize="11px"
              color="text.secondary"
              sx={{ whiteSpace: "nowrap", ml: 1 }}
            >
              Tray {String(item.slot_id).slice(0, 1)}
            </Typography>
          </Box>

          {/* DESCRIPTION */}
          <Typography
            fontSize="11px"
            color="#718198"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              mt: "6px",
            }}
          >
            {truncateText(item.mv_description, 35)}
          </Typography>

          {/* BOTTOM */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mt: "10px",
            }}
          >
            {/* PRICE BOX */}
            <Box
              sx={{
                display: "flex",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                overflow: "hidden",
                width: "130px",
                height: "48px",
                flexShrink: 0,
                boxShadow: "4px 4px 10px 0px rgb(0 0 0 / 9%)",
                background: "linear-gradient(180deg, rgba(56, 79, 111, 0.002) 0%, rgba(56, 79, 111, 0.05) 100%)",

              }}
            >
              {/* TRIAL PRICE */}
              <Box sx={{ width: "80px", textAlign: "center", py: 1 }}>
                <Typography fontSize="10px" color="text.secondary">
                  Trial Price
                </Typography>
                <Typography fontSize="14px" fontWeight={700} color="#00B177">
                       ₹{calculateFinalPrice(item).toFixed(2)}

                </Typography>
              </Box>

              <Divider orientation="vertical" flexItem />

              {/* MRP */}
              <Box sx={{ width: "80px", textAlign: "center", py: 1 }}>
                <Typography fontSize="10px" color="text.secondary">
                  MRP
                </Typography>
                <Typography
                  fontSize="13px"
                  color="text.secondary"
                  sx={{ textDecoration: "line-through" }}
                >
                  ₹{item.mrp}
                </Typography>
              </Box>
            </Box>

            {/* ADD / COUNTER */}
            {item.mycount > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  bgcolor: "#00B177",
                  color: "#fff",
                  borderRadius: "8px",
                  fontWeight: 600,
                  minWidth: "90px",
                  height: "30px",
                }}
              >
                <Button
                  onClick={(e) =>
                    onDecrement(e, index, item.slot_id, item.mycount)
                  }
                  sx={{ minWidth: "28px", color: "#fff" }}
                >
                  -
                </Button>

                <Typography fontWeight={600} fontSize="14px">
                  {item.mycount}
                </Typography>

                <Button
                  onClick={(e) =>
                    onIncrement(
                      e,
                      index,
                      item.slot_id,
                      item.mycount,
                      "add"
                    )
                  }
                  sx={{ minWidth: "28px", color: "#fff" }}
                >
                  +
                </Button>
              </Box>
            ) : <>{ item.active_count > 0 && item.active ?<>
            
              <Button
                variant="outlined"
                size="small"
                onClick={(e) =>
                  onIncrement(e, index, item.slot_id, 0, "add")
                }
                sx={{
                  borderColor:"#00B177",
                  color:"#00B177",
                  borderRadius: "8px",
                  fontWeight: 400,
                  textTransform: "none",
                  minWidth: "90px",
                     "&:hover": {
      borderColor: "#00B177",
      color: "#00B177",
      backgroundColor: "transparent", // keeps it clean (optional)
    },
                 
                }}
              >
                Add
              </Button></>:<>
              
                <Button
                variant="outlined"
                size="small"
          /*       onClick={(e) =>
                  onIncrement(e, index, item.slot_id, 0, "add")
                } */
                sx={{
                    background: "#E5E7EB",
                   color: "#fff",
                  borderRadius: "8px",
                  fontWeight: 400,
                  textTransform: "none",
                  minWidth: "90px",
                  border:"none"
                 
                }}
              >
                Add
              </Button>
              </>}
            </>}
          </Box>
        </Box>
      </Box>

      {/* OFFER SECTION */}
     {item?.offer_details && (
  <>
    {/* ✅ Full width dotted divider */}
    <Divider
      sx={{
        borderBottom:  "1px dotted #384f6f77",
        opacity: 0.8,
      }}
    />

    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.8,
        bgcolor: "#fafafa",
      }}
    >


<Chip
  label={`${item?.offer_details?.flatTypeId === 1 ? "₹" : ""}${item?.offer_details?.flatAmount || 0}${item?.offer_details?.flatTypeId === 2 ? "%" : ""}${item?.offer_details?.couponType === "CashBack" ? " Cashback" : item?.offer_details?.couponType === "Discount" ? " Off" : ""}`}
  size="small"
  sx={{
    bgcolor: "#e8f5e9",
    color: "#00B177",
    fontWeight: 700,
    fontSize: "11px",
  }}
/>
      <Typography fontSize="11px" color="#908E8E">
        Applied At Checkout
      </Typography>

      <Typography fontSize="11px" color="#908E8E">
        |
      </Typography>

      <Typography fontSize="11px" color="#908E8E">
        Consent Required
      </Typography>
    </Box>
  </>
)}
    </Card>
  );
};
// ── Main Component ────────────────────────────────────────────────────────────

const InventoryList = ({ items , GotoDetails,onDecrement,onIncrement,openSearch,openFilter,view,setView}) => {
  const [layout, setLayout] = useState("grid");

logger.log("items",items)
  return (
    <Box sx={{ maxWidth: 480, mx: "auto",}}>
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
   
     
          <LayoutToggle layout={layout} setLayout={setLayout} openSearch={openSearch} openFilter={openFilter}/>
        

      </Box>

      {/* Grid layout */}
      {layout === "grid" && (
        <Grid container spacing={1.5}>
          {items.map((item,index) => (
            <Grid item xs={6} key={item.id}>
              <GridCard   GotoDetails={GotoDetails} index={index} item={item} onIncrement={onIncrement}  onDecrement={onDecrement} />
            </Grid>
          ))}
        </Grid>
      )}

      {/* List layout */}
      {layout === "list" && (
        <Box>
          {items.map((item,index) => (
            <ListCard   GotoDetails={GotoDetails} key={item.id} index={index} item={item} onIncrement={onIncrement}  onDecrement={onDecrement} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default InventoryList;